import { defineExperiment } from "../defineExperiment";

export const WEB_LOCALIZED_PRICING_FEB23 = defineExperiment("WEB_LOCALIZED_PRICING_FEB23");
